import { useQuery } from 'react-query';
import create from 'zustand';
import { getHurdlrAccessToken } from 'services/bankAccounts';
import { useEffect, useState } from 'react';
import { getHurdlrAccountantToken } from 'services/Hurdlr/hurdlrAccountants';

interface HurdlrAccessToken {
  accessToken: undefined | string;
  setAccessToken: (accessToken: string) => void;
}

export const useHurdlrAccessToken = create<HurdlrAccessToken>((set) => ({
  accessToken: undefined,
  setAccessToken: (accessToken: string) => set({ accessToken }),
}));

export const useHurdlrAccount = (businessId: string) => {
  const [ready, setReady] = useState(false);
  const setAccessToken = useHurdlrAccessToken((state) => state.setAccessToken);
  const { data } = useQuery(['hurdlr-access-token', businessId], async () =>
    getHurdlrAccessToken(businessId),
  );
  useEffect(() => {
    if (data != null) {
      setAccessToken(data);
      setReady(true);
    }
  }, [setAccessToken, data]);

  return {
    ready,
  };
};

export const useHurdlrAccountantAccess = (organizationId: string) => {
  const [ready, setReady] = useState(false);
  const setAccessToken = useHurdlrAccessToken((state) => state.setAccessToken);
  const { data } = useQuery(
    ['hurdlr-admin-access-token', organizationId],
    async () => getHurdlrAccountantToken(organizationId),
  );
  useEffect(() => {
    if (data != null) {
      setAccessToken(data.accessToken);
      setReady(true);
    }
  }, [setAccessToken, data]);

  return {
    ready,
  };
};
